import { useDrawerUrlFlag } from '../../../../common/hooks/useDrawerUrlFlag';
import { DIRECTOR_DRAWER_PARAM } from './ManagementProfileTabConstants';

/** Publishes `?directorDrawer=true` while the Director Details drawer is open — AskAicaV2 hides its
 * floating icon off that flag (isAnyDrawerOpen) — and clears it again, including on unmount. */
export const useDirectorDrawerUrlFlag = (isDrawerOpen: boolean) => useDrawerUrlFlag(isDrawerOpen, DIRECTOR_DRAWER_PARAM);

export default useDirectorDrawerUrlFlag;
